import shopifyGenericDefaults from '../shopify-generic/config.js';

// handle image switcher on plp
function handleProductImageSwitcher(tile) {
  const currentProduct = window.document.querySelector(`.card-${tile.getAttribute('data-product-id')}`);
  const currentImage = currentProduct.querySelector('.media-image');
  const newImageSrc = tile.getAttribute('data-image-url');
  const allPaginationItems = currentProduct.querySelectorAll('.product-card-carousel-pagination-item');
  const currentPaginationItem = currentProduct.querySelector(
    `[data-carousel-pagination="${tile.getAttribute('data-carousel-tile')}"]`,
  );

  if (currentImage && newImageSrc && currentPaginationItem && allPaginationItems) {
    currentImage.src = newImageSrc;
    allPaginationItems.forEach((item) => item.classList.remove('active'));
    currentPaginationItem.classList.add('active');
  }
}

const defaultUpdateCallback = shopifyGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchResult',
).updateCallback;
shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchResult').updateCallback = () => {
  defaultUpdateCallback();

  const productTiles = window.document.querySelectorAll('.carousel-tile');

  if (productTiles) {
    productTiles.forEach((tile) => {
      tile.onmouseover = () => {
        handleProductImageSwitcher(tile);
      };

      tile.onmouseover = () => {
        handleProductImageSwitcher(tile);
      };
    });
  }
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  pagination: {
    centralRange: 1,
    disableDelimeters: true,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchHeader',
          'FacetDialog',
          'SearchVehicleWidget',
          'HeaderVehicleWidget',
          'VerifyFitment',
        ].includes(w.name),
    ),
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'title': 'Name, A-Z',
        'title:desc': 'Name, Z-A',
        'collection_sort': 'Featured',
        'price': 'Price, Low to High',
        'price:desc': 'Price, High to Low',
        'published_at': 'Date, Old to New',
        'published_at:desc': 'Date, New to Old',
      },
    },
    {
      name: 'CustomSearchHeader',
      type: 'SearchPage',
      location: {
        insertAfter: ['.\\#page-header'],
      },
      template: 'CustomSearchHeader',
      visibleIf: () =>
        window.location.pathname.includes('/search') || window.location.pathname.includes('/collections/'),
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-ymm',
        class: 'cm_vehicle-widget__header-desktop @width:default',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 650,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
    },
    {
      name: 'HeaderVehicleWidget__mobile',
      type: 'VehicleWidget',
      location: { selector: '#cm-ymm-mobile', class: 'cm_vehicle-widget__mobile cm_desktop-hide' },
      isAlwaysColumnLayout: true,
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'CustomFacetDialog',
      type: 'ContextDialog',
      location: { class: 'FacetDialog' },
      template: 'CustomFacetDialog',
      isAlwaysActive: true,
    },
    {
      name: 'CustomFacetDialogButton',
      type: 'DialogButton',
      dialogName: 'CustomFacetDialog',
    },
    {
      name: 'CustomFacetDialogFacetPanel',
      type: 'FacetPanel',
    },
    {
      name: 'CustomFacetDialogVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'CustomVehicleSpecs',
      type: 'VehicleWidget',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.extraFields,
      visibleIf: () => !!window.Convermax.config?.extraFieldsAsFilters,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
    },
  ],
};
